module.exports = __webpack_public_path__ + "img/BookIcon.0ad1c14a.svg";